module.exports = __webpack_public_path__ + "static/media/Banner-FAQ.6f7aae98.png";